import { Element } from "@api/models/Element";
import { OnlineProvider } from "@api/enums/Session/OnlineProviderEnum";
import { DateTime } from "luxon";

export interface DistributedItems<T = Element> {
    past: T[];
    today: T[];
    future: T[];
}

export class AgendaTime {
    static inFututre(beginAt: DateTime | string, dayStart: DateTime) {
        if (!(beginAt instanceof DateTime)) {
            beginAt = DateTime.fromISO(beginAt)
        }

        return beginAt >= dayStart;
    }

    static inToday(beginAt: DateTime | string, dayStart: DateTime, dayEnd: DateTime) {
        if (!(beginAt instanceof DateTime)) {
            beginAt = DateTime.fromISO(beginAt)
        }

        return beginAt >= dayStart && beginAt <= dayEnd
    }

    static inPast(endAt: DateTime | string, agenda: Element, useAddFields = true) {
        const now = DateTime.local();
        if (!(endAt instanceof DateTime)) {
            endAt = DateTime.fromISO(endAt)
        }

        return endAt < now && (useAddFields ? agenda.onlineProvider === OnlineProvider.pastSessionRecord : true);
    }
}

export class AgendaDistributer {

    /**
     * Distributes agendas according to their time
     * @param agendas
     * @returns
     */
    static distribute(agendas: Element[], dayStart: DateTime, dayEnd: DateTime, useAddFields = true): DistributedItems<Element> {
        const past: Element[] = [], today: Element[] = [], future: Element[] = [];

        agendas.forEach(item => {
            if (AgendaTime.inPast(item.endAt, item, useAddFields)) { past.push(item); }
            if (AgendaTime.inToday(item.beginAt, dayStart, dayEnd)) { today.push(item); }
            if (AgendaTime.inFututre(item.beginAt, dayStart)) { future.push(item); }
        })

        return {
            past,
            today,
            future
        }
    }

    static getPastAgendas(agendas: Element[]) {
        return agendas.filter(agenda => AgendaTime.inPast(agenda.endAt, agenda))
    }

    static getTodayAgendas(agendas: Element[], dayStart: DateTime, dayEnd: DateTime) {
        return agendas.filter(agenda => AgendaTime.inToday(agenda.beginAt, dayStart, dayEnd))
    }

    static getFtureAgendas(agendas: Element[], dayStart: DateTime) {
        return agendas.filter(agenda => AgendaTime.inFututre(agenda.beginAt, dayStart))
    }
}